import { useParams } from 'react-router-dom';
import { useHasGate, useLimit } from '../../auth/hooks/authHooks';
import { knowledgeBaseMigrationReportSync } from '../../migration-handler/singleton/migrationHandler';
import { GATES } from '../../utils/gatesUtils';
import { useAppSelector } from '../../utils/hooks';
import { useFetchKnowledgeBase, useFetchKnowledgeBases } from '../queries/KnowledgeBasesQuery';
import { selectKnowledgeBaseId } from '../selectors/knowledgeBaseDetails';
export const useCurrentKnowledgeBaseId = () => {
  const {
    knowledgeBaseId: currentKnowledgeBaseIdString
  } = useParams();
  const knowledgeBaseIdFromState = useAppSelector(selectKnowledgeBaseId);
  if (!currentKnowledgeBaseIdString) return knowledgeBaseIdFromState;
  const knowledgeBaseId = parseInt(currentKnowledgeBaseIdString, 10);
  return knowledgeBaseId;
};
export const useFetchCurrentKnowledgeBase = () => {
  const currentKnowledgeBaseId = useCurrentKnowledgeBaseId();
  return useFetchKnowledgeBase(currentKnowledgeBaseId);
};
export const useGetKnowledgeBaseLimitOverage = () => {
  const {
    hasGate
  } = useHasGate(GATES.KNOWLEDGE_BASE_V3_1);
  const {
    limit: knowledgeBaseLimit
  } = useLimit('knowledge-bases');
  const {
    data: knowledgeBases
  } = useFetchKnowledgeBases();
  if (!hasGate) {
    return {
      isOverLimit: Boolean(knowledgeBases && knowledgeBaseLimit && knowledgeBaseLimit < knowledgeBases.length),
      overageCount: knowledgeBases && knowledgeBaseLimit ? knowledgeBases.length - knowledgeBaseLimit : 0
    };
  }
  const {
    new: newKBs,
    legacy
  } = knowledgeBaseMigrationReportSync();
  return {
    isOverLimit: Boolean(knowledgeBaseLimit && (knowledgeBaseLimit < newKBs.length || knowledgeBaseLimit < legacy.length)),
    overageCount: knowledgeBaseLimit ? knowledgeBaseLimit < legacy.length ? legacy.length - knowledgeBaseLimit : newKBs.length - knowledgeBaseLimit : 0
  };
};